import React from 'react';
import { Box, Typography } from '@material-ui/core';
import cx from 'classnames';

import { translate } from '../../../../utils/helpers';
import useStyles from './styles';

interface ResultsDetailsProps {
  percents?: number | null;
  correct?: number | null;
  total?: number | null;
  wrapperClass?: string;
}

const ResultsDetails: React.FC<ResultsDetailsProps> = ({
  percents,
  correct,
  total,
  wrapperClass,
}) => {
  const classes = useStyles();

  return (
    <Box className={cx(classes.wrapper, wrapperClass)}>
      <Typography className={classes.percents}>{percents}%</Typography>
      <Typography className={classes.details}>
        {translate('page.pathway.testDetails', { correct, total })}
      </Typography>
    </Box>
  );
};

export default ResultsDetails;
